if (!customElements.get('product-description-show-more')) {
  customElements.define(
    'product-description-show-more',
    class ProductDescriptionShowMore extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('.product__description-content');
        this.button = this.querySelector('.product__description-show-more');
        this.showMoreText = this.querySelector('.product__description-show-more-text');
        this.showLessText = this.querySelector('.product__description-show-less-text');

        if (!this.content || !this.button) return;

        this.button.addEventListener('click', () => this.toggle());
        requestAnimationFrame(() => this.update());
        window.addEventListener('load', () => this.update(), { once: true });
        this.content.querySelectorAll('img').forEach((image) => {
          if (!image.complete) {
            image.addEventListener('load', () => this.update(), { once: true });
          }
        });

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.update());
          this.resizeObserver.observe(this.content);
        }
      }

      disconnectedCallback() {
        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        }
      }

      isOverflowing() {
        const styles = getComputedStyle(this.content);
        const collapsedHeight =
          parseFloat(styles.maxHeight) || 20 * parseFloat(getComputedStyle(document.documentElement).fontSize);

        return this.content.scrollHeight > collapsedHeight + 1;
      }

      update() {
        if (this.classList.contains('is-expanded')) return;

        const isOverflowing = this.isOverflowing();
        this.button.hidden = !isOverflowing;
        this.classList.toggle('is-overflowing', isOverflowing);
      }

      toggle() {
        if (this.classList.contains('is-expanded')) {
          this.collapse();
        } else {
          this.expand();
        }
      }

      expand() {
        this.classList.add('is-expanded');
        this.button.setAttribute('aria-expanded', 'true');
        if (this.showMoreText) this.showMoreText.hidden = true;
        if (this.showLessText) this.showLessText.hidden = false;
      }

      collapse() {
        this.content.scrollTop = 0;
        this.classList.remove('is-expanded');
        this.button.setAttribute('aria-expanded', 'false');
        if (this.showMoreText) this.showMoreText.hidden = false;
        if (this.showLessText) this.showLessText.hidden = true;
        this.update();
      }
    }
  );
}
